<template>
    <div class="content">
        <div class="LogReg">
            <statusBar></statusBar>
            <div class="header">
                <div class="logo">
                    <img :src="logoUrl" />
                </div>
            </div>
            <div class="LogReg-content">
                <div class="tabs">
                    <div class="tab-item" :class="{ 'act': act == 1 }" @click="onChangeTab(1)">
                        <img :src="$themeImage('common.gift')" alt="" class="empty_img">
                        {{ $t("login.SignUp")
                    }}</div>
                    <div class="tab-item" :class="{ 'act': act == 2 }" @click="onChangeTab(2)">
                        {{ $t("login.SignIn") }}
                    </div>
                </div>
                <div class="form-box">
                    <transition :name="authTransitionName" mode="out-in">
                    <div class="form" v-if="act == 1" key="signup">
                        <a-form-model ref="ruleForm1" :model="form1" :rules="rules1" @submit.native.prevent>
                            <a-form-model-item ref="phone" label="" prop="phone">
                                <a-input v-model="form1.phone" type="number" :placeholder="$t('login.phone')" class="phone">
                                    <language slot="prefix" :show="true" :showIcon="true"></language>
                                    <span slot="prefix">{{ phoneCode }}</span>
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="password">
                                <a-input-password v-model="form1.password" :placeholder="$t('login.password')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="matchPassword">
                                <a-input-password v-model="form1.matchPassword" :placeholder="$t('login.ConfirmPwdAgain')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                            <a-form-model-item ref="inviteUrl" label="" prop="inviteUrl">
                                <a-input v-model="form1.inviteMemberId" :disabled="!!$store.getters.invitCode"
                                    :placeholder="$t('login.InvitationCode')">
                                    <i slot="prefix" class="iconfont icon-shebeizhuce" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model>
                        <div class="remember">
                            <div class="check-box" @click="argeeService = !argeeService">
                                <i v-if="argeeService" class="iconfont icon-xuanzeyixuanze checked"></i>
                                <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                            </div>
                            <div class="tips">
                                {{ $t('login.OverAgeAgree') }}
                                <span class="txt">《{{ $t("login.TermsOfService") }}》</span>
                            </div>
                        </div>
                    </div>
                    <div class="form" v-else key="signin">
                        <a-form-model ref="ruleForm2" :model="form2" :rules="rules2" @submit.native.prevent>
                            <a-form-model-item ref="phone" label="" prop="phone">
                                <a-input v-model="form2.phone" :placeholder="$t('login.accountOrPhone')" class="account">
                                    <language slot="prefix" :show="true" :showIcon="true"></language>
                                    <!-- <span slot="prefix">{{ phoneCode }}</span> -->
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="password">
                                <a-input-password v-model="form2.password" :placeholder="$t('login.password')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                        </a-form-model>
                        <div class="remember">
                            <div class="check-box" @click="rememberMe = !rememberMe">
                                <i v-if="rememberMe" class="iconfont icon-xuanzeyixuanze checked"></i>
                                <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                            </div>
                            <div class="tips">
                                {{ $t("login.RememberYouraccountPassword") }}
                            </div>
                        </div>
                    </div>
                    <!-- 注册倒计时 -->
                    </transition>
                    <div v-if="act == 1 && !isCanRegister" class="time_down_box">
                        <div class="time_down">
                            <div class="time_down_title">{{ $t("login.downTime") }}</div>
                            <div class="time_down_time">
                                <span>{{ $t("login.also") }}：</span>
                                <van-count-down :time="timestamp" :format="'DD ' + $t('login.day') + ' HH:mm:ss'">
                                </van-count-down>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="act == 1" class="bonus-btn-wrap">
                <div class="bonus-badge">
                    <img class="bonus-badge__icon" :src="$themeImage('common.gift')" alt="">
                    <span>+{{ eventRegisterReward }}</span>
                </div>
                <a-button class="btn btn-bonus" @click="handleSubmit('ruleForm1')">Regístrate Para Obtener Un Bono</a-button>
            </div>
            <a-button v-else class="btn" @click="handleSubmit('ruleForm2')">{{ $t("login.SignIn") }}</a-button>
            <div v-if="showExitConfirm" class="exit-confirm-mask" @click.self="showExitConfirm = false">
                <div class="exit-confirm-box">
                    <img class="bg-exit-confirm" :src="$themeImage('login.exitConfirmBg')" alt="">
                    <div class="exit-confirm">
                        <div class="exit-confirm__title">Obtenga un bono de registro</div>
                        <div class="exit-confirm__amount">{{ eventRegisterReward }}</div>
                        <div class="exit-confirm__desc">¿Está seguro de que quieres renunciar a la recompensa que está a tu alcance?</div>
                        <div class="exit-confirm__actions">
                            <div class="exit-confirm__btn exit-confirm__btn--primary" @click="showExitConfirm = false">Continuar Con El Registro</div>
                            <div class="exit-confirm__btn exit-confirm__btn--ghost" @click="forceClose">Rechazo Cruel</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="close-icon" @click="onRequestClose">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="close">
                <path fill-rule="evenodd"
                    d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                    clip-rule="evenodd"></path>
            </svg>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { login, getUserInfo, userRegisterByBash64 } from '@/api/user'
import { getNationInfo } from '@/api/system'
import md5 from 'md5'
import language from '@/components/language'
import statusBar from '@/components/statusBar'
import { domainName } from '@/common/http'
export default {
    name: 'accountForm',
    components: { language, statusBar },
    data() {
        const validatePass1 = (rule, value, callback) => {
            const reg = /^[a-zA-Z0-9]{6,16}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.AccountFormat')))
            } else {
                callback()
            }
        }
        const validatePass2 = (rule, value, callback) => {
            // const reg = /^(?=.*[a-zA-Z])[a-zA-Z0-9\W_]{8,16}$/g
            const reg = /^(?=\S)(?!.*\s$).{6,}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.PasswordFormat')))
            } else {
                if (this.form1.password !== '') {
                    this.$refs.ruleForm1.validateField('password')
                }
                callback()
            }
        }
        const validatePass3 = (rule, value, callback) => {
            // const reg = /^(?=.*[a-zA-Z])[a-zA-Z0-9\W_]{8,16}$/g
            const reg = /^(?=\S)(?!.*\s$).{6,}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.PasswordFormat')))
            } else {
                if (this.form1.matchPassword !== '') {
                    this.$refs.ruleForm1.validateField('matchPassword')
                }
                callback()
            }
        }
        return {
            domainName,
            act: 1,
            prevAct: 1,
            argeeService: true,
            rememberMe: true,
            debounceTimer: null,
            form1: {
                phone: '',
                password: '',
                matchPassword: '',
                inviteMemberId: ''
            },
            rules1: {
                phone: [
                    { required: true, message: this.$t('login.PleaseEnterYourPhoneNumber'), trigger: 'blur' },
                    { validator: validatePass1, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('login.PleaseEnterPassword'), trigger: 'blur' },
                    { validator: validatePass2, trigger: 'blur' }
                ],
                matchPassword: [{ validator: validatePass3, trigger: 'blur' }]
            },
            form2: {
                phone: '',
                password: ''
            },
            rules2: {
                phone: [{ required: true, message: this.$t('login.PleaseEnterAccount'), trigger: 'blur' }],
                password: [{ required: true, message: this.$t('login.PleaseEnterPassword'), trigger: 'blur' }]
            },

            showExitConfirm: false,
            isCanRegister: true,
            timestamp: 0,
            timeData: {},

            phoneCode: ''
        }
    },
    props: {
        isCanClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        telegramUserId() {
            return this.$store.getters.telegramUserId
        },
        authTransitionName() {
            return this.act > this.prevAct ? 'auth-drawer-next' : 'auth-drawer-prev'
        },
        eventRegisterReward() {
            return this.$store.state.user.eventRegisterReward
        }
    },
    created() {
        this.open()
    },
    methods: {
        close() {
            this.$emit('close')
        },
        onRequestClose() {
            if (this.act === 1 && this.eventRegisterReward) {
                this.showExitConfirm = true
                return
            }
            this.close()
        },
        forceClose() {
            this.showExitConfirm = false
            this.close()
        },
        open() {
            const that = this
            that.act = that.$store.getters.loginType
            if (that.act === 1) that.getDownTimes()
            that.form1.inviteMemberId = that.$store.getters.invitCode || ''
            const rememberInfo = this.$store.getters.rememberInfo
            const form = rememberInfo ? JSON.parse(rememberInfo) : null
            if (form) {
                this.form2.phone = form.phone
                this.form2.password = form.password
            }
            this.onClearValidate()
            getNationInfo().then((res) => {
                if (!res) return
                if (res.code) return
                const D = res.result
                D.forEach(x => {
                    if (this.BelongNation === x.enumName) {
                        this.phoneCode = '+' + x.code
                    }
                })
            })
        },
        onChangeTab(type) {
            this.prevAct = this.act
            this.act = type
            this.onClearValidate()
            this.$store.dispatch('user/changeLoginType', type)
        },
        onClearValidate() {
            this.$nextTick(() => {
                if (this.act === 1) {
                    this.$refs.ruleForm1?.clearValidate()
                }
                if (this.act === 2) {
                    this.$refs.ruleForm2?.clearValidate()
                }
            })
        },
        handleSubmit(formName) {
            const that = this
            clearTimeout(that.debounceTimer)
            that.debounceTimer = setTimeout(() => {
                that.$refs[formName].validate(valid => {
                    if (valid) {
                        if (that.act === 1) {
                            const formData = that.form1
                            if (!that.argeeService) {
                                Toast(that.$t('login.PleaseAgreeOverAge'))
                                return
                            }
                            if (formData.password !== formData.matchPassword) {
                                Toast(that.$t('login.InconsistentPassword'))
                                return
                            }
                            clearTimeout(that.debounceTimer)
                            that.debounceTimer = setTimeout(() => {
                                const userAgent = navigator.userAgent
                                const params = {
                                    ...formData,
                                    // password: md5(formData.password),
                                    // matchPassword: md5(formData.matchPassword),
                                    password: btoa(formData.password),
                                    matchPassword: btoa(formData.matchPassword),
                                    userAgent
                                }
                                const Pixel = that.$store.getters.Pixel
                                if (Pixel) {
                                    params.trafficAcquisitionType = Pixel
                                }
                                const clickId = that.$store.getters.ClickId
                                if (clickId) {
                                    params.clickId = clickId
                                }
                                if (that.$store.getters.TaId) {
                                    params.taid = that.$store.getters.TaId
                                }
                                userRegisterByBash64(params).then(res => {
                                    Toast(res?.message)
                                    if (!res?.code) {
                                        that.$store.dispatch('user/setInvitCode', '')
                                        that.form1.inviteMemberId = ''
                                        that.$store.dispatch('user/changeLoginType', 2)
                                        that.act = 2
                                        that.form2.phone = formData.phone
                                        that.form2.password = formData.password
                                        // login(formData).then(loginRes => {
                                        //     if (loginRes.code === 0) {
                                        //         that.$store.commit('user/SET_TOKEN', `${loginRes.result.tokenHead} ${loginRes.result.token}`)
                                        //         getUserInfo().then((uInfo) => {
                                        //             if (uInfo.code) return
                                        //             that.$store.dispatch('user/saveUserInfo', uInfo.result)
                                        //             that.$websocket.initWebSocket()
                                        //         })
                                        //         that.$store.dispatch('user/setIsShowLoginPopup', false)
                                        //         that.$emit('loginSucc')
                                        //     }
                                        // })
                                    }
                                }).finally(() => {
                                    // uni.hideLoading()
                                })
                            }, 300)
                        } else if (that.act === 2) {
                            that.$store.commit('user/SET_TOKEN', '')
                            const formdata = that.form2
                            const params = {
                                ...formdata,
                                password: md5(formdata.password)
                            }
                            if (that.telegramUserId) {
                                params.telegramUserId = that.telegramUserId
                            }
                            const equipmentId = that.$store.state.system.equipmentId
                            if (equipmentId) params.equipmentId = equipmentId
                            login(params).then(res => {
                                // Toast(res?.message)
                                if (res?.code === 0) {
                                    that.$store.dispatch('user/setInvitCode', '')
                                    that.$store.dispatch('system/setTelegramUserId', '')
                                    if (that.rememberMe) {
                                        that.$store.dispatch('user/setRememberMe', formdata)
                                    } else {
                                        that.$store.dispatch('user/setRememberMe', null)
                                    }
                                    that.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                                    that.$forceUpdate()
                                    getUserInfo().then((uInfo) => {
                                        if (uInfo.code) return
                                        that.$websocket.initWebSocket()
                                    })
                                    that.$store.dispatch('user/setIsShowLoginPopup', false)
                                    that.$emit('loginSucc')
                                }
                            }).finally(() => {
                                // uni.hideLoading()
                            })
                        }
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }, 300)
        },
        getDownTimes() {
            const that = this
            let sysConfig = that.$store.getters.sysConfig
            if (!sysConfig) {
                const getGonfigInterval = setInterval(() => {
                    sysConfig = that.$store.getters.sysConfig
                    if (sysConfig) {
                        clearInterval(getGonfigInterval)
                        const currentTime = that.getLocalTime()
                        const launchTime = sysConfig.systemLaunchTime ? new Date(sysConfig.systemLaunchTime).getTime() : that.getLocalTime()
                        if (launchTime > currentTime) {
                            that.timestamp = launchTime - currentTime
                            that.isCanRegister = false
                        }
                    }
                }, 300)
            } else {
                const currentTime = that.getLocalTime()
                const launchTime = sysConfig.systemLaunchTime ? new Date(sysConfig.systemLaunchTime).getTime() : that.getLocalTime()
                if (launchTime > currentTime) {
                    that.timestamp = launchTime - currentTime
                    that.isCanRegister = false
                }
            }
        },
        onTimeDownChange(e) {
            this.timeData = e
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.content {
    background-image: var(--theme-login-popup-image-bg),var(--theme-home-frame-corner-top-left),var(--theme-home-frame-corner-top-right),var(--theme-home-frame-corner-bottom-left),var(--theme-home-frame-corner-bottom-right), var(--theme-popup-bg);
    background-size: 100% 100%,139px 83px,139px 83px,139px 83px,139px 83px,100% 100%;
    background-position: center center,top left,top right,bottom left,bottom right,center center;
    background-repeat: no-repeat;
    border-radius: .3rem;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 700px;
    position: relative;
    .close-icon {
        position: absolute;
        background: var(--theme-popup-close-bg);
        border: .01rem solid var(--theme-popup-close-border);
        width: .68rem;
        height: .68rem;
        top: 0;
        right: -.88rem;
        border-radius: .12rem;
        align-items: center;
        justify-content: center;
        font-size: .34rem;
        display: flex;
        cursor: pointer;

        svg {
            fill: $font-title-color;
        }
    }
    @keyframes move {
        0%, 65% {
            transform: rotate(0);
        }
        70% {
            transform: rotate(6deg);
        }
        75% {
            transform: rotate(-6deg);
        }
        80% {
            transform: rotate(6deg);
        }
        85% {
            transform: rotate(-6deg);
        }
        90% {
            transform: rotate(6deg);
        }
        95% {
            transform: rotate(-6deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    &>.LogReg {
        width: 430px;
        height: 100%;

        .header {
            padding: .4rem .3rem .2rem .3rem;
            position: relative;

            .logo {
                height: auto;
                width: 50%;
                margin: 0 auto;

                >img {
                    /* 关键1：宽度铺满父级，高度自动按比例缩放 */
                    width: 100%;
                    /* 关键2：高度自动，保证图片比例不变 */
                    height: auto;
                    /* 可选：防止图片被拉伸变形 */
                    object-fit: cover; /* 常用值：cover（铺满容器，裁剪超出）/contain（完整显示，可能留空白） */
                    /* 可选：垂直居中（如果父级有固定高度） */
                    display: block; /* 消除图片默认的行内空白 */
                    margin: 0 auto; /* 水平居中 */
                }
            }
        }

        .LogReg-content {
            padding: 0;
            margin: 0 .26rem;
            background: var(--theme-popup-panel-bg);
            box-shadow: var(--theme-popup-panel-shadow);
            border-radius: .36rem;
            box-sizing: border-box;
            border: .01rem solid transparent;
            background-image:
                linear-gradient(to right, var(--theme-popup-panel-fill), var(--theme-popup-panel-fill)),
                var(--theme-popup-panel-border);
            background-origin: border-box;
            background-clip: content-box, border-box;
        }

        .tabs {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 .6rem;
            margin-top: .38rem;
            border-radius: 1rem;
            background-color: var(--theme-popup-tabs-bg);

            .tab-item {
                color: $font-component-muted-color;
                box-sizing: border-box;
                font-size: .3rem;
                cursor: pointer;
                height: .88rem;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                border-radius: 1rem;
                position: relative;

                &.act {
                    color: var(--theme-gold-text);
                    background: var(--theme-gold-bg);
                }

                .empty_img {
                    width: .6rem;
                    height: .6rem;
                    margin-right: .08rem;
                    animation: move 3s linear infinite;
                    margin-left: -.6rem;
                }
            }
        }

        .form-box {
            position: relative;

            .time_down_box {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 999;
                background: var(--theme-popup-mask-bg);
                box-sizing: border-box;
                padding-top: 1px;

                .time_down {
                    width: 300px;
                    height: 120px;
                    margin: 0 auto;
                    box-sizing: border-box;
                    background: var(--theme-popup-box-bg);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    border-radius: 10px;
                    color: $font-color;
                    margin-top: 56px;

                    .time_down_title {
                        font-size: 18px;
                        margin-bottom: 12px;
                    }

                    .time_down_time {
                        font-size: 15px;
                        display: flex;
                        align-items: center;

                        .time {
                            color: $font-component-hot-strong-color;
                            font-weight: bold;
                            font-size: 16px;
                        }
                    }
                }
            }

            .form {
                padding: .32rem .26rem;
                padding-top: .42rem;
                text-align: left;

                ::v-deep .ant-form {
                    .ant-form-item {
                        margin-bottom: .28rem;

                        &.ant-form-item-with-help {
                            margin-bottom: .0rem;
                        }

                        .language {
                            width: auto;
                            height: auto;
                            padding-right: .12rem;
                            // border-right: .01rem solid $bg-popup-color;
                        }
                    }

                    .has-error {
                        .ant-input-prefix {
                            .iconfont {
                                position: relative;

                                &:after {
                                    content: '*';
                                    position: absolute;
                                    color: $font-error-color;
                                    top: .02rem;
                                    right: -.1.5rem;
                                    font-size: .24rem;
                                }
                            }
                        }

                        .ant-form-explain {
                            height: .42rem;
                            line-height: .2rem;
                            font-size: 0.18rem;
                            padding: .04rem 0;
                            box-sizing: border-box;

                            &:not(.show-help-leave)::before {
                                background-color: $font-error-color;
                                border-radius: 50%;
                                content: "!";
                                color: var(--theme-bright-text);
                                height: 0.18rem;
                                margin-right: 0.1rem;
                                visibility: visible;
                                width: 0.18rem;
                                display: inline-block;
                                text-align: center;
                                // background-image: url('@/assets/icons.png');
                                background-position: -15.509rem -4.59rem;
                                background-size: 13.689rem 13.419rem;
                            }
                        }
                    }
                }

                .ant-input-affix-wrapper {
                    background-color: transparent;

                    &.phone {
                        ::v-deep input::-webkit-outer-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input[type='number'] {
                            -moz-appearance: textfield;
                        }

                        ::v-deep .ant-input {
                            padding-left: 1.3rem !important;
                        }
                    }

                    &.account {

                        ::v-deep .ant-input {
                            padding-left: .8rem !important;
                        }
                    }

                    ::v-deep .ant-input-prefix {
                        left: .14rem;
                        color: $font-iconfont-color;

                        .icon-person,
                        .icon-mima {
                            font-size: .37rem;
                        }

                        .icon-mima {
                            font-size: .34rem;
                        }

                        .icon-open {
                            font-size: .2rem;
                        }

                        .icon-key-fill {
                            font-size: .34rem;
                        }

                        .icon-shebeizhuce {
                            font-size: .34rem;
                        }

                        .flag {
                            width: .28rem;
                            height: 0.22rem;
                            margin-right: .1rem;
                        }

                        span {
                            font-size: .23rem;
                            // margin-right: .1rem;
                            padding-right: .1rem;
                            color: var(--theme-bright-text);
                            border-right: .01rem solid var(--theme-list-row-border);
                            display: inline-block;
                        }
                    }

                    ::v-deep .ant-input {
                        // background-color: $bg-component-input-focus-color !important;
                        border-radius: 0.14rem;
                        font-size: 0.26rem;
                        height: 0.85rem;
                        padding: 0 0.62rem !important;
                        border-radius: .2rem;
                        color: var(--theme-bright-text);
                        border: .01rem solid var(--theme-input-border);
                        background: var(--theme-input-bg);

                        &:focus {
                            background-color: var(--theme-input-focus-bg);
                            border: .01rem solid var(--theme-input-focus-border) !important;
                        }

                        &::-webkit-input-placeholder {
                            /* WebKit browsers */
                            font-size: .27rem;
                            color: var(--theme-input-placeholder);
                            // opacity: .9;
                            font-weight: 400 !important;
                        }

                        &:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            font-size: .22rem;
                            color: var(--theme-input-placeholder);
                        }

                        &::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            font-size: .22rem;
                            color: var(--theme-input-placeholder);
                        }

                        &:-ms-input-placeholder {
                            /* Internet Explorer 10+ */
                            font-size: .22rem;
                            color: var(--theme-input-placeholder);
                        }
                    }

                    ::v-deep .ant-input-suffix {
                        .ant-input-clear-icon {
                            color: var(--theme-input-placeholder);
                            font-size: .32rem;
                        }
                    }

                    &.ant-input-password {
                        ::v-deep .ant-input {
                            padding-right: 1rem;
                        }

                        ::v-deep .ant-input-suffix {
                            .ant-input-password-icon {
                                margin-right: .1rem;
                                font-size: .3rem;
                                color: var(--theme-input-placeholder);
                            }
                        }
                    }
                }

                .remember {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    padding: 0 .2rem;

                    .check-box {
                        margin-bottom: .01rem;
                        margin-right: .1rem;
                        cursor: pointer;

                        &>i {
                            width: .26rem;
                            height: .26rem;
                            border: .02rem solid var(--theme-input-border);
                            border-radius: .04rem;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            background: var(--theme-input-bg);
                            color: transparent;
                            font-size: .22rem;
                            box-sizing: border-box;
                        }

                        &>i.checked {
                            color: var(--theme-active-text);
                            border-color: var(--theme-signin-accent-text);
                            background: var(--theme-signin-accent-text);
                        }
                    }

                    .txt {
                        color: var(--theme-signin-accent-text);
                        font-size: .21rem;
                        cursor: pointer;
                    }

                    .tips {
                        color: var(--theme-bright-text);
                        font-size: .22rem;
                        line-height: .38rem;
                        margin-top: 0.03rem;
                    }
                }

                .function {
                    display: flex;
                    justify-content: space-between;

                    span {
                        color: $font-component-gold-base-color;
                        font-size: .21rem;
                        cursor: pointer;
                    }
                }
            }
        }
        .btn {
            display: inline-block;
            font-size: .28rem;
            height: .8rem;
            text-align: center;
            line-height: .8rem;
            border-radius: 1rem;
            background: var(--theme-gold-bg);
            color: var(--theme-gold-text);
            font-weight: bold;
            margin: .4rem 0;
            margin-bottom: .5rem;
            cursor: pointer;
            padding: 0 .5rem;

            &.ant-btn {
                border-color: transparent;
            }
        }
    }
}

.exit-confirm-mask {
    position: absolute;
    inset: 0;
    background: var(--theme-popup-overlay-bg);
    backdrop-filter: blur(.08rem);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 30;
    box-sizing: border-box;
}
.exit-confirm-box{
    position: relative;
    width: 100%;
    max-width: 10rem;
    // padding-bottom: .2rem;

    & > img.bg-exit-confirm{
        width: 100%;
        height: auto;
        vertical-align: middle;
    }
}
.exit-confirm {
    border-radius: .22rem;
    position: absolute;
    bottom: 0;
    left: 1rem;
    right: 1rem;
    background: var(--theme-popup-box-bg);
    border: 1px solid var(--theme-popup-box-border);
    box-shadow: var(--theme-popup-box-shadow);
    padding: .36rem .34rem .3rem;
    text-align: center;

    &__title {
        font-size: .34rem;
        line-height: 1.35;
        color: $font-color;
        font-weight: 700;
    }

    &__amount {
        margin-top: .22rem;
        font-size: .62rem;
        line-height: 1;
        color: var(--theme-popup-amount-text);
        font-weight: 800;
        text-shadow: 0px 4px 10px rgba(0,0,0,0.3);
    }

    &__desc {
        margin-top: .24rem;
        color: var(--theme-bright-text);
        opacity: .85;
        font-size: .26rem;
        line-height: .4rem;
    }

    &__actions {
        margin-top: .34rem;
        display: flex;
        flex-direction: column;
        gap: .3rem;
    }

    &__btn {
        height: .82rem;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .28rem;
        font-weight: 700;
        cursor: pointer;
        user-select: none;
    }

    &__btn--primary {
        color: var(--theme-gold-text);
        background: var(--theme-gold-bg);
    }

    &__btn--ghost {
        background: var(--theme-popup-box-bg);
        border: 1px solid var(--theme-popup-box-border);
        box-shadow: var(--theme-popup-box-shadow);
    }
}

.bonus-btn-wrap {
    position: relative;
}

.bonus-badge {
    position: absolute;
    left: calc(50% + .72rem);
    right: auto;
    top: .06rem;
    z-index: 3;
    height: .46rem;
    padding: 0 .04rem 0 .42rem;
    width: auto;
    min-width: 1.52rem;
    border-radius: .14rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: $font-color;
    font-size: .2rem;
    font-weight: 700;
    background: transparent;
    box-shadow: none;

    &__icon {
        position: absolute;
        left: 0;
        top: 50%;
        width: .58rem;
        height: .58rem;
        transform: translateY(-50%);
        transform-origin: 50% 50%;
        animation: badge-shake 1.15s ease-in-out infinite;
        object-fit: contain;
        pointer-events: none;
    }

    span {
        display: inline-flex;
        align-items: center;
        height: .28rem;
        padding: 0 .08rem;
        border-radius: .08rem;
        background: linear-gradient(180deg, #ff6b7b 0%, #d80f32 100%);
        box-shadow: 0 .02rem .06rem rgba(68, 0, 9, .3);
        color: var(--theme-bright-text);
        line-height: .28rem;
    }
}

.btn-bonus {
    padding: 0 .32rem !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

@keyframes badge-shake {
    0%, 100% {
        transform: translateY(-50%) translate(0, 0) rotate(0deg) scale(1);
    }

    16% {
        transform: translateY(-50%) translate(-.02rem, .01rem) rotate(-8deg) scale(1.05);
    }

    32% {
        transform: translateY(-50%) translate(.025rem, -.01rem) rotate(7deg) scale(1.03);
    }

    48% {
        transform: translateY(-50%) translate(-.018rem, 0) rotate(-5deg) scale(1.04);
    }

    64% {
        transform: translateY(-50%) translate(.014rem, .006rem) rotate(4deg) scale(1.02);
    }

    80% {
        transform: translateY(-50%) translate(0, 0) rotate(0deg) scale(1);
    }
}
</style>
